import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {SharedUiDialogModule} from "@snelstart/ui-dialog";
import {SharedUiListModule} from "@snelstart/ui-list";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import { ErrorMessage } from '../services/rekenclient.api';
import {SharedUiLoadingModule} from "@snelstart/ui-loading";

@Component({
  selector: 'snelstart-venture-fiscaal-domain-logic-validatie',
  standalone: true,
    imports: [
        SharedUiDialogModule,
        SharedUiListModule,
        SharedUiButtonModule,
        SharedUiAlertModule,
        SharedUiLoadingModule
    ],
  templateUrl: './validatie.component.html',
  styleUrl: './validatie.component.css'
})
export class ValidatieComponent implements OnChanges {

  @Input() public id: any;
  @Input() public type: any;
  @Input() public validaties: any;
  @Input() public validatieList: any;
  @Input() public dialogVisible = false;
  @Output() public dialogVisibleChange = new EventEmitter<boolean>();

  public showSpinner = true;

  ngOnChanges(){
    this.showSpinner = true;
    setTimeout(() => {
      this.showSpinner = false;
    }, 1500);

    const exceptionWords = [
      { camelCase: 'aangifteJaar', replacement: 'aangiftejaar' },
      { camelCase: 'huisNummer', replacement: 'huisnummer' },
      { camelCase: 'partnerAangifte', replacement: 'partneraangifte' },
      { camelCase: 'landCode', replacement: 'landcode' },
      { camelCase: 'box3.leningen', replacement: 'box3.schulden' },
      { camelCase: 'wozNummerWaarLeningBijHoort', replacement: 'selecteer box 3-woning' },
      { camelCase: 'trialBalanceItems', replacement: '' },
    ];

    if (this.validatieList && this.validatieList.map) {
      this.validatieList?.map((errorMessage: ErrorMessage) => {
        if (errorMessage.error) {
          let errorText = errorMessage.error;

          // Handle server errors or null pointers
          if (errorText.includes('server') || errorText === null || errorText === undefined) {
            errorText = 'Er zijn onvoldoende gegevens voor volledige validatie';
            errorMessage.message = 'Het lijkt erop dat de aangifte nog niet (volledig) is ingevuld. Controleer of alle gegevens correct en volledig zijn ingevuld en valideer daarna opnieuw.'
          }

          errorText = errorText.replace(/partnerAangifte.aangever/g, 'partner');
          errorText = errorText.replace(/begiftigde/g, 'ontvanger');

          exceptionWords.forEach(({ camelCase, replacement }) => {
            const regex = new RegExp(camelCase, 'g');
            errorText = errorText.replace(regex, replacement);
          });

          errorText = errorText.replace(/([a-z])([A-Z])/g, '$1 $2');
          errorText = errorText.toLowerCase();
          errorText = errorText.replace(/\[(\d+)\]/g, (_, match) => {
            const num = parseInt(match);
            return ' > ' + (num + 1) + 'e regel';
          });
          errorText = errorText.replace(/ondernemingen > 1e regel/g, 'onderneming');
          errorText = errorText.replace(/jaarrekeningen > 1e regel/g, 'jaarrekening');

          errorText = errorText.replace(/schenking > 1e regel./g, '');
          errorText = errorText.replace(/aangifte db/g, 'Algemene gegevens');
          errorText = errorText.replace(/contact persoon/g, 'contactpersoon');

          errorText = errorText.replace(/Box(\d+)/g, 'Box $1');
          errorText = errorText.replace(/box(\s+)(\d+)/g, 'box $2');
          errorText = errorText.replace(/box(\s+)(\d+)/g, 'box $2');

          errorText = errorText.replace(/sen oaftrek/g, 'aftrek speur & ontwikkeling');

          errorText = errorText.replace(/(box)(\d+)/gi, (match, p1, p2) => {
            return p1.charAt(0).toUpperCase() + p1.slice(1) + ' ' + p2;
          });
          errorText = errorText.replace(/([a-z])([A-Z])/g, '$1 $2');
          errorText = errorText.replace(/&euro;/g, '€');
          errorText = errorText.replace(/<br>/g, ';');
          errorMessage.error = '' + errorText.replace(/\./g, ' > ');
          // console.log('error', errorText)
          errorMessage.error = this.capitalizeFirstLetter(errorText.replace(/\./g, ' > '));
        }
        if (errorMessage.error === null || errorMessage.error === undefined) {
          errorMessage.error = '' + this.capitalizeFirstLetter(errorMessage.message || '');
        }
        return errorMessage;
      });
    }
    if (this.validatieList && this.validatieList.sort) {
      this.validatieList.sort((a: ErrorMessage, b: ErrorMessage) => {
        const errorTextA = (a.error || '').toLowerCase();
        const errorTextB = (b.error || '').toLowerCase();
        return errorTextA.localeCompare(errorTextB);
      });
    }
  }

  capitalizeFirstLetter(text: string): string {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}
